<template>
    <UiCard class="ui-card--empty">
        <slot />
    </UiCard>
</template>

<script setup lang="ts">
</script>
